import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ReturnExceptionBatchApproveDTO } from '../model/returnExceptionBatchApproveDTO';
import { ReturnExceptionBatchCancelDTO } from '../model/returnExceptionBatchCancelDTO';
import { ReturnExceptionCancelDTO } from '../model/returnExceptionCancelDTO';
import { ReturnExceptionSearchDTO } from '../model/returnExceptionSearchDTO';
import { ReturnExceptionVO } from '../model/returnExceptionVO';
import { PageInfoReturnExceptionSummaryVO } from '../model/pageInfoReturnExceptionSummaryVO';
import { BASE_PATH } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';

@Injectable({
  providedIn: 'root',
})
export class ReturnExceptionControllerService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: Configuration,
  ) {
    super(basePath, configuration);
  }

  public page(
    body: ReturnExceptionSearchDTO,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<PageInfoReturnExceptionSummaryVO> {
    return this.requestJson<PageInfoReturnExceptionSummaryVO>(
      'post',
      `/v1/return-exceptions/page`,
      body,
      observe,
      reportProgress,
      options,
    );
  }

  public getById(
    id: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<ReturnExceptionVO> {
    return this.requestJson<ReturnExceptionVO>(
      'get',
      `/v1/return-exceptions/${encodeURIComponent(String(id))}`,
      undefined,
      observe,
      reportProgress,
      options,
    );
  }

  public approve(
    id: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<ReturnExceptionVO> {
    return this.requestJson<ReturnExceptionVO>(
      'post',
      `/v1/return-exceptions/${encodeURIComponent(String(id))}/approve`,
      undefined,
      observe,
      reportProgress,
      options,
    );
  }

  public cancel(
    id: number,
    body: ReturnExceptionCancelDTO,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<ReturnExceptionVO> {
    return this.requestJson<ReturnExceptionVO>(
      'post',
      `/v1/return-exceptions/${encodeURIComponent(String(id))}/cancel`,
      body,
      observe,
      reportProgress,
      options,
    );
  }

  public approveBatch(
    body: ReturnExceptionBatchApproveDTO,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<ReturnExceptionVO>> {
    return this.requestJson<Array<ReturnExceptionVO>>(
      'post',
      `/v1/return-exceptions/approve-batch`,
      body,
      observe,
      reportProgress,
      options,
    );
  }

  public cancelBatch(
    body: ReturnExceptionBatchCancelDTO,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<ReturnExceptionVO>> {
    return this.requestJson<Array<ReturnExceptionVO>>(
      'post',
      `/v1/return-exceptions/cancel-batch`,
      body,
      observe,
      reportProgress,
      options,
    );
  }

  private requestJson<T>(
    method: 'get' | 'post' | 'put',
    localVarPath: string,
    body: unknown,
    observe: any,
    reportProgress: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    localVarHeaders = this.configuration.addCredentialToHeaders(
      'BearerAuthentication',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['*/*']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected,
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();
    const localVarTransferCache: boolean = options?.transferCache ?? true;

    if (body !== undefined) {
      const consumes: string[] = ['application/json'];
      const httpContentTypeSelected: string | undefined =
        this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set(
          'Content-Type',
          httpContentTypeSelected,
        );
      }
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<T>(method, `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe,
      transferCache: localVarTransferCache,
      reportProgress,
    });
  }
}
